import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import "./Tab.css";

export default function ShareTabPanel({ tabs, title }) {
  const [value, setValue] = React.useState(tabs[0]?.key ?? "0");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  return (
    <TabContext value={value}>
      <Box className="tab-panel-root">
        {title && (
          <h3 style={{ textTransform: "capitalize" }}>{title}</h3>
        )}
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="dynamic tabs"
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.key}
              sx={tabStyle}
              value={tab.key}
              label={tab.label}
              icon={tab.icon}
              iconPosition={tab.icon ? "start" : undefined}
              className="custom-tab"
            />
          ))}
        </Tabs>
        {tabs.map((tab) => (
          <TabPanel value={tab.key} key={tab.key} className="custom-tab-panel">
            {tab.children}
          </TabPanel>
        ))}
      </Box>
    </TabContext>
  );
}
